import posthog from 'posthog-js'

const projectToken = import.meta.env.VITE_PUBLIC_POSTHOG_PROJECT_TOKEN
const host = import.meta.env.VITE_PUBLIC_POSTHOG_HOST
const environment = import.meta.env.VITE_APP_ENV ?? 'local'

const deployed = environment !== 'local'

export const posthogEnabled = deployed && Boolean(projectToken && host)

if (posthogEnabled) {
  posthog.init(projectToken, {
    api_host: host,
    defaults: '2026-01-30',
    logs: {
      serviceName: 'adlovin-web',
      environment,
    },
    capture_exceptions: {
      capture_unhandled_errors: true,
      capture_unhandled_rejections: true,
      capture_console_errors: false,
    },
  })
} else if (deployed) {
  console.error(
    `PostHog is not configured for "${environment}": VITE_PUBLIC_POSTHOG_PROJECT_TOKEN and VITE_PUBLIC_POSTHOG_HOST are both required. No analytics or logs are being sent.`,
  )
}

export default posthog
